import React, { useEffect, useState } from "react";
import {
  Box,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

import {
  Grid,
  MenuItem,
  FormControl,
  Select,
  TextField,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { PlusIcon } from "../assets/icons";
import { Close, Delete } from "@mui/icons-material";

const FabricationMachine = ({
  scopeOfWork,
  index,
  fabMachine,
  handleInputChange,
  categoryLabels,
  selectedMachines,
  subCategories,
  handleMachineSelection,
  handleDeleteMachineSelectionFab,
  errors,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const MachineModalOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <div className="border  rounded-lg mb-5 pb-2">
      <div className="flex justify-between items-center w-full bg-[#e0edf4] p-3 rounded-t-lg">
        <h1 className="font-[600]">Fabrication Machine Required</h1>
        <button
          className="btn flex items-center gap-2 rounded-lg shadow-lg text-white px-4 py-2 bg-[var(--primary-color)]"
          onClick={() => MachineModalOpen()}
        >
          <PlusIcon color="white" size="14px" /> Add Machine
        </button>
      </div>
      {
        <Modal open={isOpen} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400, // Adjust width as needed
              bgcolor: "white", // Background color
              boxShadow: 24, // Adds shadow
              borderRadius: "8px", // Rounded corners
            }}
          >
            <div className="border w-full flex justify-between items-center bg-blue-400  p-3 rounded-lg">
              <Typography variant="h6" component="h2" sx={{ color: "white" }}>
                Select Machines
              </Typography>
              <IconButton onClick={handleClose} sx={{ color: "white" }}>
                <Close />
              </IconButton>
            </div>
            <FormControl
              fullWidth
              sx={{
                marginTop: "0.5rem",
                marginBottom: "7px",
                borderRadius: 2,
                padding: "16px",
              }}
            >
              <FormGroup>
                {fabMachine.map((machine, i) => (
                  <FormControlLabel
                    key={i}
                    control={
                      <Checkbox
                        checked={selectedMachines.includes(machine.type)}
                        onChange={() => handleMachineSelection(machine.type)}
                      />
                    }
                    label={<span className="">{machine.type}</span>}
                  />
                ))}
              </FormGroup>
            </FormControl>
          </Box>
        </Modal>
      }

      {selectedMachines.map((selectedType, i) => {
        const machine = scopeOfWork.machinesNeededForFabrication.find(
          (m) => m.type === selectedType
        );
        if (!machine || !machine.details) return null;
        return (
          <div
            key={i}
            className="mt-4 shadow-md rounded-lg px-10 py-2 border mx-4"
          >
            <div className="flex justify-between items-center ">
              <label className="font-semibold">{machine?.type || ""}</label>
              <IconButton
                onClick={() => handleDeleteMachineSelectionFab(machine.type)}
              >
                <Delete sx={{ color: "var(--error-color)" }} />
              </IconButton>
            </div>
            <div className="border w-full  my-1 rounded-lg" />

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 p-4">
              {Object.keys(machine.details).map((field, fieldIndex) => (
                <div key={fieldIndex}>
                  {selectedMachines[i] === "Welding Machine" ? (
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ marginBottom: "7px" }}
                    >
                      <label
                        style={{
                          fontWeight: "400",
                          marginBottom: "0.5rem",
                        }}
                      >
                        {categoryLabels[field]}
                      </label>
                      {field === "subCategory" ? (
                        <Select
                          size="small"
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details[field] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <span className="text-[var(--listdown-color)]">
                                  Select Type of Welding Machine
                                </span>
                              );
                            }
                            return selected;
                          }}
                          inputProps={{ "aria-label": `Select ${field}` }}
                        >
                          {subCategories["Welding Machine"]?.map(
                            (weldingMachine, i) => {
                              return (
                                <MenuItem value={weldingMachine.value} key={i}>
                                  <Radio
                                    checked={
                                      scopeOfWork?.machinesNeededForFabrication.find(
                                        (m) => m.type === selectedType
                                      )?.details[field] === weldingMachine.value
                                    }
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        handleInputChange(
                                          {
                                            target: {
                                              name: `machinesNeededForFabrication-details-${machine.type}-${field}-${index}`,
                                              value: weldingMachine.value,
                                            },
                                          },
                                          index
                                        );
                                      }
                                    }}
                                    style={{ paddingRight: "8px" }}
                                  />
                                  {weldingMachine.value}
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      ) : field === "ampereOfMachine" ? (
                        <TextField
                          fullWidth
                          size="small"
                          select // Enables dropdown
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details["ampereOfMachine"] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          required
                        >
                          <MenuItem value={200}>200 A</MenuItem>
                          <MenuItem value={300}>300 A</MenuItem>
                          <MenuItem value={400}>400 A</MenuItem>
                        </TextField>
                      ) : (
                        // : field === "controllerSetting" ? (
                        //   <TextField
                        //     fullWidth
                        //     select // Enables dropdown
                        //     size="small"
                        //     name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                        //     value={
                        //       scopeOfWork?.machinesNeededForFabrication.find(
                        //         (m) => m.type === selectedType
                        //       )?.details["controllerSetting"] || ""
                        //     }
                        //     onChange={(e) => {
                        //       handleInputChange(e, index);
                        //     }}
                        //     required
                        //   >
                        //     <MenuItem value={"Digital"}> Digital</MenuItem>
                        //     <MenuItem value={"Manual"}> Manual</MenuItem>
                        //   </TextField>
                        // ) :
                        <TextField
                          fullWidth
                          select // Enables dropdown
                          size="small"
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details["ageOfMachine"] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          required
                        >
                          <MenuItem value="0-4">0 to 4 years</MenuItem>
                          <MenuItem value="4+">4 years and above</MenuItem>
                        </TextField>
                      )}
                    </FormControl>
                  ) : selectedMachines[i] === "Paint Compressor Machine" ? (
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ marginBottom: "7px" }}
                    >
                      <label
                        style={{
                          fontWeight: "400",
                          marginBottom: "0.5rem",
                        }}
                      >
                        {categoryLabels[field]}
                      </label>
                      {field === "subCategory" ? (
                        <Select
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details[field] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <span className="text-[var(--listdown-color)]">
                                  Select Type of Machine
                                </span>
                              );
                            }
                            return selected;
                          }}
                          inputProps={{ "aria-label": `Select ${field}` }}
                        >
                          {subCategories["Paint Compressor Machine"]?.map(
                            (paintMachine, i) => {
                              return (
                                <MenuItem value={paintMachine.value} key={i}>
                                  <Radio
                                    checked={
                                      scopeOfWork?.machinesNeededForFabrication.find(
                                        (m) => m.type === selectedType
                                      )?.details[field] === paintMachine.value
                                    }
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        handleInputChange(
                                          {
                                            target: {
                                              name: `machinesNeededForFabrication-details-${machine.type}-${field}-${index}`,
                                              value: paintMachine.value,
                                            },
                                          },
                                          index
                                        );
                                      }
                                    }}
                                    style={{ paddingRight: "8px" }}
                                  />
                                  {paintMachine.value}
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      ) : (
                        <TextField
                          fullWidth
                          select // Enables dropdown
                          size="small"
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details["ageOfMachine"] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          required
                        >
                          <MenuItem value="0-4">0 to 4 years</MenuItem>
                          <MenuItem value="4+">4 years and above</MenuItem>
                        </TextField>
                      )}
                    </FormControl>
                  ) : selectedMachines[i] === "CNC Router Machine" ? (
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ marginBottom: "7px" }}
                    >
                      <label
                        style={{
                          fontWeight: "400",
                          marginBottom: "0.5rem",
                        }}
                      >
                        {categoryLabels[field]}
                      </label>
                      {field === "subCategory" ? (
                        <Select
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details[field] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <span className="text-[var(--listdown-color)]">
                                  Select Type of Machine
                                </span>
                              );
                            }
                            return selected;
                          }}
                          inputProps={{ "aria-label": `Select ${field}` }}
                        >
                          {subCategories["CNC Router Machine"]?.map(
                            (subCategoryOfMachine, i) => {
                              return (
                                <MenuItem
                                  value={subCategoryOfMachine.value}
                                  key={i}
                                >
                                  <Radio
                                    checked={
                                      scopeOfWork?.machinesNeededForFabrication.find(
                                        (m) => m.type === selectedType
                                      )?.details[field] ===
                                      subCategoryOfMachine.value
                                    }
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        handleInputChange(
                                          {
                                            target: {
                                              name: `machinesNeededForFabrication-details-${machine.type}-${field}-${index}`,
                                              value: subCategoryOfMachine.value,
                                            },
                                          },
                                          index
                                        );
                                      }
                                    }}
                                    style={{ paddingRight: "8px" }}
                                  />
                                  {subCategoryOfMachine.value}
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      ) : field === "powerOfMachine" ? (
                        <TextField
                          fullWidth
                          select // Enables dropdown
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details["powerOfMachine"] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          required
                          size="small"
                        >
                          <MenuItem value={2.5}>2.5 kW</MenuItem>
                          <MenuItem value={3.5}>3.5 kW</MenuItem>
                          <MenuItem value={4.5}>4.5 kW</MenuItem>
                          <MenuItem value={6}>6 kW</MenuItem>
                          <MenuItem value={7.5}>7.5 kW</MenuItem>
                        </TextField>
                      ) : field === "lengthFoot" ? (
                        /* Length Dropdown */
                        <Grid item xs={12} sm={6} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            select
                            name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                            value={
                              scopeOfWork?.machinesNeededForFabrication.find(
                                (m) => m.type === selectedType
                              )?.details[field] || ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, index);
                            }}
                            required
                          >
                            <MenuItem value={8}>8'</MenuItem>
                            <MenuItem value={10}>10'</MenuItem>
                            <MenuItem value={12}>12'</MenuItem>
                          </TextField>
                        </Grid>
                      ) : field === "breadthFoot" ? (
                        /* Width (Breadth) - Auto Updated */
                        <Grid item xs={12} sm={6} md={6}>
                          <TextField
                            fullWidth
                            size="small"
                            name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                            value={
                              scopeOfWork?.machinesNeededForFabrication.find(
                                (m) => m.type === selectedType
                              )?.details[field] || ""
                            }
                            InputProps={{
                              readOnly: true, // Prevent manual editing
                            }}
                          />
                        </Grid>
                      ) : (
                        <TextField
                          fullWidth
                          select // Enables dropdown
                          size="small"
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details["ageOfMachine"] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          required
                        >
                          <MenuItem value="0-4">0 to 4 years</MenuItem>
                          <MenuItem value="4+">4 years and above</MenuItem>
                        </TextField>
                      )}
                    </FormControl>
                  ) : selectedMachines[i] ===
                    "Acrylic Laser Cutting Machine" ? (
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ marginBottom: "7px" }}
                    >
                      <label style={{ fontWeight: "400" }}>
                        {categoryLabels[field]}
                      </label>
                      {field === "subCategory" ? (
                        <Select
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details[field] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <span className="text-[var(--listdown-color)]">
                                  Select Type of Machine
                                </span>
                              );
                            }
                            return selected;
                          }}
                          inputProps={{ "aria-label": `Select ${field}` }}
                          sx={{ marginTop: "0.5rem" }}
                        >
                          {subCategories["Acrylic Laser Cutting Machine"]?.map(
                            (subCategoryOfMachine, i) => {
                              return (
                                <MenuItem
                                  value={subCategoryOfMachine.value}
                                  key={i}
                                >
                                  <Radio
                                    checked={
                                      scopeOfWork?.machinesNeededForFabrication.find(
                                        (m) => m.type === selectedType
                                      )?.details[field] ===
                                      subCategoryOfMachine.value
                                    }
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        handleInputChange(
                                          {
                                            target: {
                                              name: `machinesNeededForFabrication-details-${machine.type}-${field}-${index}`,
                                              value: subCategoryOfMachine.value,
                                            },
                                          },
                                          index
                                        );
                                      }
                                    }}
                                    style={{ paddingRight: "8px" }}
                                  />
                                  {subCategoryOfMachine.value}
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      ) : field === "lengthFoot" ? (
                        /* Length Dropdown */
                        <Grid item xs={12} sm={6} md={6}>
                          {/* <InputLabel className="mb-1">
                                    Length (foot)*
                                  </InputLabel> */}
                          <TextField
                            fullWidth
                            size="small"
                            sx={{ marginTop: "0.5rem" }}
                            select
                            name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                            value={
                              scopeOfWork?.machinesNeededForFabrication.find(
                                (m) => m.type === selectedType
                              )?.details[field] || ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, index);
                            }}
                            required
                          >
                            <MenuItem value={2}>2'</MenuItem>
                            <MenuItem value={3}>3'</MenuItem>
                            <MenuItem value={8}>8'</MenuItem>
                          </TextField>
                        </Grid>
                      ) : field === "breadthFoot" ? (
                        /* Width (Breadth) - Auto Updated */
                        <Grid item xs={12} sm={6} md={6}>
                          {/* <InputLabel className="mb-1">
                                  Breadth (foot)*
                                </InputLabel> */}
                          <TextField
                            fullWidth
                            size="small"
                            sx={{ marginTop: "0.5rem" }}
                            name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                            value={
                              scopeOfWork?.machinesNeededForFabrication.find(
                                (m) => m.type === selectedType
                              )?.details[field] || ""
                            }
                            InputProps={{
                              readOnly: true, // Prevent manual editing
                            }}
                          />
                        </Grid>
                      ) : (
                        <TextField
                          fullWidth
                          size="small"
                          sx={{ marginTop: "0.5rem" }}
                          select // Enables dropdown
                          // label="ageOfMachine"
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details["ageOfMachine"] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          required
                        >
                          <MenuItem value="0-4">0 to 4 years</MenuItem>
                          <MenuItem value="4+">4 years and above</MenuItem>
                        </TextField>
                      )}
                    </FormControl>
                  ) : selectedMachines[i] ===
                    "Channel Letter Bending Machine" ? (
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ marginBottom: "7px" }}
                    >
                      <label style={{ fontWeight: "400" }}>
                        {categoryLabels[field]}
                      </label>
                      {field === "subCategory" ? (
                        <Select
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details[field] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <span className="text-[var(--listdown-color)]">
                                  Select Type of Machine
                                </span>
                              );
                            }
                            return selected;
                          }}
                          inputProps={{ "aria-label": `Select ${field}` }}
                          sx={{ marginTop: "0.5rem" }}
                        >
                          {subCategories["Channel Letter Bending Machine"]?.map(
                            (subCategoryOfMachine, i) => {
                              return (
                                <MenuItem
                                  value={subCategoryOfMachine.value}
                                  key={i}
                                >
                                  <Radio
                                    checked={
                                      scopeOfWork?.machinesNeededForFabrication.find(
                                        (m) => m.type === selectedType
                                      )?.details[field] ===
                                      subCategoryOfMachine.value
                                    }
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        handleInputChange(
                                          {
                                            target: {
                                              name: `machinesNeededForFabrication-details-${machine.type}-${field}-${index}`,
                                              value: subCategoryOfMachine.value,
                                            },
                                          },
                                          index
                                        );
                                      }
                                    }}
                                    style={{ paddingRight: "8px" }}
                                  />
                                  {subCategoryOfMachine.value}
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      ) : field === "lengthFoot" ? (
                        /* Length Dropdown */
                        <Grid item xs={12} sm={6} md={6}>
                          {/* <InputLabel className="mb-1">
                                    Length (foot)*
                                  </InputLabel> */}
                          <TextField
                            fullWidth
                            size="small"
                            sx={{ marginTop: "0.5rem" }}
                            select
                            name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                            value={
                              scopeOfWork?.machinesNeededForFabrication.find(
                                (m) => m.type === selectedType
                              )?.details[field] || ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, index);
                            }}
                            required
                          >
                            <MenuItem value={5}>5'</MenuItem>
                            <MenuItem value={4}>4'</MenuItem>
                            <MenuItem value={3}>3'</MenuItem>
                          </TextField>
                        </Grid>
                      ) : field === "breadthFoot" ? (
                        /* Width (Breadth) - Auto Updated */
                        <Grid item xs={12} sm={6} md={6}>
                          {/* <InputLabel className="mb-1">
                                  Breadth (foot)*
                                </InputLabel> */}
                          <TextField
                            fullWidth
                            size="small"
                            sx={{ marginTop: "0.5rem" }}
                            name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                            value={
                              scopeOfWork?.machinesNeededForFabrication.find(
                                (m) => m.type === selectedType
                              )?.details[field] || ""
                            }
                            InputProps={{
                              readOnly: true, // Prevent manual editing
                            }}
                          />
                        </Grid>
                      ) : field === "modelMachine" ? (
                        <>
                          <label>Select Machine Model</label>

                          <Select
                            name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                            value={
                              scopeOfWork?.machinesNeededForFabrication.find(
                                (m) => m.type === selectedType
                              )?.details[field] || ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, index);
                            }}
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span className="text-[var(--listdown-color)]">
                                    Select Machine Model
                                  </span>
                                );
                              }
                              return selected;
                            }}
                            inputProps={{ "aria-label": `Select ${field}` }}
                            sx={{ marginTop: "0.5rem" }}
                          >
                            <RadioGroup>
                              {[
                                {
                                  label: "Flat Aluminum",
                                  value: "Flat Aluminum",
                                },
                                {
                                  label: "Trim Cap Aluminum",
                                  value: "Trim Cap Aluminum",
                                },
                              ].map((option, i) => (
                                <MenuItem key={i} value={option.value}>
                                  <Radio
                                    checked={
                                      scopeOfWork?.machinesNeededForFabrication.find(
                                        (m) => m.type === selectedType
                                      )?.details[field] === option.value
                                    }
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        handleInputChange(
                                          {
                                            target: {
                                              name: `machinesNeededForFabrication-details-${machine.type}-${field}-${index}`,
                                              value: option.value,
                                            },
                                          },
                                          index
                                        );
                                      }
                                    }}
                                    style={{ paddingRight: "8px" }}
                                  />
                                  {option.label}
                                </MenuItem>
                              ))}
                            </RadioGroup>
                          </Select>
                        </>
                      ) : field === "wattage" ? (
                        <>
                          <label>Wattage Of Machine</label>
                          <TextField
                            fullWidth
                            size="small"
                            sx={{ marginTop: "0.5rem" }}
                            select
                            // label="Wattage of Machine"
                            name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                            value={
                              scopeOfWork?.machinesNeededForFabrication.find(
                                (m) => m.type === selectedType
                              )?.details["wattage"] || ""
                            }
                            onChange={(e) => {
                              handleInputChange(e, index);
                            }}
                            required
                          >
                            {[
                              { label: "1500 W", value: "1500" },
                              { label: "800 W", value: "800" },
                              { label: "200 W", value: "200" },
                            ].map((option, i) => (
                              <MenuItem key={i} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </>
                      ) : (
                        <TextField
                          fullWidth
                          size="small"
                          sx={{ marginTop: "0.5rem" }}
                          select // Enables dropdown
                          // label="ageOfMachine"
                          name={`machinesNeededForFabrication-details-${machine.type}-${field}-${index}`}
                          value={
                            scopeOfWork?.machinesNeededForFabrication.find(
                              (m) => m.type === selectedType
                            )?.details["ageOfMachine"] || ""
                          }
                          onChange={(e) => {
                            handleInputChange(e, index);
                          }}
                          required
                        >
                          <MenuItem value="0-4">0 to 4 years</MenuItem>
                          <MenuItem value="4+">4 years and above</MenuItem>
                        </TextField>
                      )}
                    </FormControl>
                  ) : (
                    <></>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}

      {errors?.machinesNeededForFabrication && (
        <p className="text-[var(--error-color)] text-[12px] ml-3">
          {errors.machinesNeededForFabrication}
        </p>
      )}
    </div>
  );
};

export default FabricationMachine;
